export default class CheckoutPaymentMethods {
	constructor(domElement = window.document) {
		// Hard binding
		this.handlePaymentMethodDescriptions =
			this.handlePaymentMethodDescriptions.bind(this);

		// Setting attributes
		this.paymentMethodsList = domElement.querySelector('#paymentMethodsList');
		if (!this.paymentMethodsList) {
			return;
		}
		this.paymentMethodsListItems = Array.from(this.paymentMethodsList.children);
		this.paymentMethodsRadioButtons = this.paymentMethodsList.querySelectorAll(
			'input[name="paymentMethod"]',
		);
		this.isActiveClass = 'checkout-payment-methods__payment-method--is-active';

		// Adding event listeners to the radio buttons
		this.setupEventsOnList();
		this.handlePaymentMethodDescriptions();
		this.setupErrorStyleEvents();
	}

	setupEventsOnList() {
		this.paymentMethodsRadioButtons.forEach(node => {
			node.addEventListener('click', this.handlePaymentMethodDescriptions);
		});
	}

	handlePaymentMethodDescriptions() {
		this.paymentMethodsListItems.forEach(node => {
			node.classList.remove(this.isActiveClass);
		});
		let selected;
		this.paymentMethodsRadioButtons.forEach(btn => {
			if (btn.checked) {
				selected = btn;
			}
		});
		this.paymentMethodsListItems.forEach(node => {
			if (node.contains(selected)) {
				node.classList.add(this.isActiveClass);
			}
		});
	}

	setupErrorStyleEvents() {
		const { events } = window.od;
		this.errorDiv = document.querySelector(
			'[data-id="checkout-payment-methods"]',
		);
		if (this.errorDiv) {
			events.subscribe('validation', this.handleValidationStyles.bind(this));
		}
	}

	handleValidationStyles(data) {
		if (!data) {
			return;
		}
		const { payload } = data;
		if (
			!(
				payload &&
				payload.field &&
				payload.field.getAttribute('name') === 'paymentMethod'
			)
		) {
			return;
		}
		if (payload.isValid) {
			this.errorDiv.classList.remove('checkout-payment-methods--is-invalid');
		} else {
			this.errorDiv.classList.add('checkout-payment-methods--is-invalid');
		}
	}
}
